import React, { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import {
  setFocus,
  FocusContext,
  useFocusable,
} from '@noriginmedia/norigin-spatial-navigation'

import tts from '../../lib/TTS.js'
import * as UI from '../../lib/ui'
import FocusableButtonTS from '../../components/FocusableButton/FocusableButtonTS'
import { PLAYER_ERROR_CODES } from '../../../../shared/components/VideoPlayer/'

import type { LivePlayerErrorProps } from './types'

const BUTTON_KEY = 'BACK'

export const LivePlayerError = (props: LivePlayerErrorProps) => {
  const navigate = useNavigate()
  const { ref } = useFocusable()
  const location = useLocation()
  const errorCode = new URLSearchParams(location.search).get('error-code')
  const errorDescription = `There was an error loading the livestream (Error: ${Object.keys(
    PLAYER_ERROR_CODES
  ).find((key) => PLAYER_ERROR_CODES[key] === errorCode)}: ${errorCode})`
  const errorTitle = 'Live TV Playback Error'

  useEffect(() => {
    if (props.isExternalFocused) {
      setFocus(BUTTON_KEY)
    } else {
      //!TODO: Error here on the argument.
      setFocus(null)
    }
  }, [props.isExternalFocused])

  useEffect(() => {
    tts.addTextToRead(`${errorTitle} .... ${errorDescription}.`)
  }, [])

  const handleEnterPress = () => {
    UI.setFocusToSidePanel()
    navigate('/livestream?fromChannelPlayback=true')
  }

  const handleFocus = () => {
    tts.enqueueTextToRead('Focus on Go back Button.')
  }

  // We shouldn't need to use this proveder here when we migrate to the new focus system the side panel.
  return (
    <FocusContext.Provider value="player-error">
      <div className="live-player-screen">
        <div className="live-player-screen__error" ref={ref}>
          <h1 className="live-player-screen__error__title">{errorTitle}</h1>
          <p className="live-player-screen__error__message">
            {errorDescription}
          </p>
          <FocusableButtonTS
            onEnterPress={handleEnterPress}
            onFocus={handleFocus}
            className="live-player-screen__error__back-button"
            focusKey={BUTTON_KEY}
          >
            Go back
          </FocusableButtonTS>
        </div>
      </div>
    </FocusContext.Provider>
  )
}
